// Styling for the selected-value subtext shown under a facet/section header for the current-selection subtext
export const selectedValueNamesClasses =
  'body-xs w-full truncate text-gray-500 group-data-[state=open]/item:min-h-[1lh] group-data-[state=closed]:empty:hidden';

// Row spacing for radio/checkbox value list items
export const valueRowClasses = 'py-2 first:pt-0 last:pb-0';
